<template>
  <div>
    <associar-integrante-add-new
      :is-dialog-open.sync="isDialogOpen"
      @refetch-data="$emit('refetch-data')"
    />

    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card class="d-flex justify-space-between">
        <v-card-title>Usuários</v-card-title>

        <v-btn
          v-if="ativo && acessoPost"
          color="primary"
          class=" ma-3"
          @click="isDialogOpen = !isDialogOpen"
        >
          <span>Adicionar</span>
        </v-btn>

        <v-btn
          v-else
          color="primary"
          class=" ma-3"
          disabled
        >
          <span>Adicionar</span>
        </v-btn>
      </v-card>

      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
          @refetch-data="$emit('refetch-data')"
        />
      </div>

      <table-associacoes-equipe-agente
        :headers="headers"
        :items="items"
        :acesso-delete="acessoDelete"
        @refetch-data="$emit('refetch-data')"
      />
    </v-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'
import AssociarIntegranteAddNew from '@/views/equipe/AssociarIntegranteAddNew.vue'
import TableAssociacoesEquipeAgente from '@/components/tables/TableAssociacoesEquipeAgente.vue'
import useAuthStore from '@/store/auth'

export default {
  components: {
    TableAssociacoesEquipeAgente,
    AssociarIntegranteAddNew,
  },

  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      idPost: 1091,
      acessoPost: true,
      idDelete: 1092,
      acessoDelete: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPost)) {
        this.acessoPost = false
      }
      if (!this.funcionalidades.includes(this.idDelete)) {
        this.acessoDelete = false
      }
    },
  },

  setup() {
    const isDialogOpen = ref(false)

    return {
      isDialogOpen,
    }
  },
}
</script>
